var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.logoSrc)?_c('img',{staticClass:"hero",attrs:{"src":_vm.logoSrc}}):(_vm.hasConfig && !_vm.isMobile)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.config.html)}}):(_vm.hasConfig && _vm.isMobile)?_c('div',_vm._l((_vm.mobileImages),function(src,i){return _c('img',{key:i,staticClass:"thumb",attrs:{"src":src}})}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }